// import Immutable from 'immutable';
import { createReducer } from '../utils';
import { actionTypes } from '../actions/sidebarActions';

const initSidebarData = {
  status: '',
};

export default createReducer(initSidebarData, {
  [actionTypes.SIDEBAR_DATA_REQUEST]: (state, { data }) => ({ ...state, ...data }),
  [actionTypes.SIDEBAR_DATA_SUCCESS]: (state, { data }) => ({ ...data }),
  [actionTypes.SIDEBAR_DATA_ERROR]: (state, { error }) => ({ error }),
});



// WEBPACK FOOTER //
// ./src/redux/reducers/sidebarReducer.js